module.exports = __webpack_public_path__ + "static/013-19d358e19bb6cecb679dc8c23236e259.jpg";